import CTA from './CTA';
import Hero from './Hero';
import What from './What';

export default function Community() {
  return (
    <>
      <Hero />
      <What />
      <CTA />
    </>
  );
}
